export function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
}

export function isNativeApp(): boolean {
  return ('Capacitor' in globalThis && (globalThis as any).Capacitor.isNative) || globalThis.location.protocol === 'capacitor:';
}
